import * as React from 'react';
import styled from 'styled-components';
import { FormInput, FormWrapper } from '../../Form/FormInput';
import { FlexRow } from '../../../Defaults/Flexbox/Flexbox';
import { rem } from 'polished';
import { prop } from '../../../../utilities';
import { __ } from 'react-i18n';
import { Select } from '../../General/Select';
import { phonePrefixes, removePhonePrefix } from '../utilities';
import { FormSelect } from '../../Form/FormSelect';

interface Props {
  initialInfo: {
    email: string;
    phone: string;
    phonePrefix: string;
  };
  onBlur: (data: any) => void;
  formProblems: any;
  emailRef: any;
  phoneRef: any;
  isB2B: boolean;
  deliveryEmail: string;
  deliveryPhone: string | undefined;
}

function ContactInfo({
  initialInfo,
  onBlur,
  formProblems,
  emailRef,
  phoneRef,
  isB2B,
  deliveryEmail,
  deliveryPhone,
}: Props) {
  let country = 'sk';
  if (window && window.location && window.location.hostname) {
    if (window.location.hostname.endsWith('.cz')) {
      country = 'cz';
    } else {
      country = 'sk';
    }
  }

  const [email, setEmail] = React.useState(initialInfo.email);
  const [phone, setPhone] = React.useState(initialInfo.phone);
  const [phonePrefix, setPhonePrefix] = React.useState(
    initialInfo.phonePrefix
      ? initialInfo.phonePrefix
      : phonePrefixes && phonePrefixes.length
      ? phonePrefixes.find(item => {
          if (country === 'sk' && item === '+421') {
            return true;
          }
          if (country === 'cz' && item === '+420') {
            return true;
          }
          return false;
        })
      : '',
  );

  React.useEffect(() => {
    if (deliveryEmail !== undefined) {
      setEmail(deliveryEmail);
    }
  }, [deliveryEmail]);

  React.useEffect(() => {
    if (deliveryPhone !== undefined) {
      setPhone(deliveryPhone);
    }
  }, [deliveryPhone]);

  const { email: emailProblem, phone: phoneProblem } = {
    email: isB2B
      ? prop(formProblems, 'delivery_address.person.email')
      : prop(formProblems, 'delivery_address.person.email') ||
        prop(formProblems, 'billing_address.person.email'),
    phone: isB2B
      ? prop(formProblems, 'delivery_address.person.phone')
      : prop(formProblems, 'delivery_address.person.phone') ||
        prop(formProblems, 'billing_address.person.phone'),
  };

  const handleBlur = () => {
    onBlur({ email, phone: phonePrefix + phone });
  };

  return (
    <Wrapper isB2B={isB2B}>
      {(!isB2B || !!email) && (
        <FormInput
          justText={isB2B}
          inputRef={emailRef}
          name={'email'}
          type="email"
          label={__('Email')}
          value={email}
          required={true}
          marginBottom={16}
          marginRight={32}
          minWidthPx={288}
          // tslint:disable-next-line:jsx-no-lambda
          onChange={e => setEmail(e.target.value)}
          onBlur={handleBlur}
          validMessage={emailProblem}
          validateAllowedChars={true}
        />
      )}

      <FormWrapper isB2B={isB2B} noWrap={true} marginRight={32}>
        {(!isB2B || (isB2B && !!phonePrefix && !!phone)) && (
          <FormSelect
            justText={isB2B}
            name="phone_prefix"
            label={__('Predvoľba')}
            value={phonePrefix}
            options={phonePrefixes.map(prefix => {
              return { value: prefix, name: prefix };
            })}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => {
              setPhonePrefix(e.target.value);
            }}
            onBlur={handleBlur}
            marginBottom={16}
            maxWidth={38}
            maxWidthPx={96}
            marginRight={16}
            height={56}
          />
        )}

        {(!isB2B || !!phone) && (
          <FormInput
            justText={isB2B}
            inputRef={phoneRef}
            name={'phone'}
            type="text"
            required={true}
            label={__('Tel. číslo')}
            value={phone}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e =>
              setPhone(removePhonePrefix(phonePrefixes, e.target.value))
            }
            onBlur={handleBlur}
            validMessage={phoneProblem}
            maxWidth={100}
            maxWidthPx={208}
            marginBottom={16}
            autoComplete="tel"
            validateAllowedChars={true}
          />
        )}
      </FormWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)<{ isB2B?: boolean }>`
  flex-flow: ${({ isB2B }) => (isB2B ? 'column' : 'row wrap')};
  margin-bottom: -${rem(16)};
`;

export { ContactInfo };
